import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewContainerRef, ɵɵsetNgModuleScope } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { paragraphMapper } from 'src/app/models/paragraphs.model';
import { stringSubstr } from 'src/app/utils.ts/helpers';

interface PartialType {
  type: string;
  [key: string]: any;
}


@Component({
  selector: 'app-service-layout',
  templateUrl: './service-layout.component.html',
  styleUrls: ['./service-layout.component.scss']
})


export class ServiceLayoutComponent implements OnInit {
  stringSubstr = stringSubstr;
  @Input() data: any; // This should have a property called paragraphs which is an array of paragraph data.
  @ViewChild('dynamicParagraph', { read: ViewContainerRef })
  dynamicParagraph!: ViewContainerRef;

  loading: boolean = true;
  partials: any
  links: any[] = [];
  jsonLdScript: any;

  constructor(dynamicParagraph: ViewContainerRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) {
    this.dynamicParagraph = dynamicParagraph;
  }
  async ngOnInit() {
    this.jsonLdScript = this.sanitizer.bypassSecurityTrustHtml(this.generateJsonLdScript());

    this.partials = Array.isArray(this.data[this.data.type + '_partials']) ? this.data[this.data.type + '_partials'] : [];

    const viewContainerRef = this.dynamicParagraph; // Move this line outside the loop
    viewContainerRef.clear(); // Clear the view container once
    if (!this.partials?.data?.length) {
      this.links = this.partials
        .map((partial: PartialType) => {
          const title = partial[partial.type + '_title'];
          if (title) {
            //replace any spacial character or space with _
            const url = title.replace(/[^a-zA-Z0-9]/g, '_');
            return {
              title,
              url
            };
          }
          return null;
        })
        .filter((link: any) => link !== null) as { title: string; url: string }[];
    } else {
      this.links = [];
    }

    for (const paragraph of this.partials) {
      const paragraphType = paragraph.type;
      const paragraphData = paragraph;

      const module: any = await paragraphMapper(paragraphType);

      if (module && module.component) {
        ɵɵsetNgModuleScope(module, {
          declarations: [module.component],
          imports: [CommonModule],
          exports: [module.component]
        });

        const componentRef: any = viewContainerRef.createComponent(module.component);
        const section = this.renderer.createElement('section');
        const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        const titleID = paragraph[paragraphType + '_title'] ? paragraph[paragraphType + '_title'].replace(/[^a-zA-Z0-9]/g, '_') : randomId;
        this.renderer.setAttribute(section, 'id', titleID);
        this.renderer.setAttribute(section, 'class', 'it-page-section anchor-offset richtext-wrapper mb-30');
        const mainContent = this.elementRef.nativeElement.querySelector('#main-content');

        if (mainContent) {
          this.renderer.appendChild(mainContent, section);
        }

        this.renderer.appendChild(section, componentRef.location.nativeElement);

        if (paragraphData) {
          componentRef.instance.data = paragraphData;
        }

        this.loading = false;
      } else {
        console.error(`Paragraph type ${paragraphType} not found`);
      }
    }

    const section: HTMLElement | null = this.elementRef.nativeElement.querySelector('#main-content');

    if (section) {
      const updatedDate: HTMLElement = this.renderer.createElement('p');
      this.renderer.setAttribute(updatedDate, 'id', 'ultimo-aggiornamento');
      this.renderer.setAttribute(updatedDate, 'class', 'text-paragraph-small mb-0');

      this.renderer.setProperty(updatedDate, 'innerHTML', `Pagina aggiornata il  ${this.formatData(this.data.changed)}`);
      this.renderer.appendChild(section, updatedDate);
    }
  }
  scrollTo(id: string) {
    document.querySelector('#' + id)?.scrollIntoView(
      {
        behavior: 'smooth'
      }
    );
  }

  formatData(data: string) {
    const date = new Date(data);
    const day = date.getDate();
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }

  cleanHtmlTags(text: string) {
    return text.replace(/<[^>]*>?/gm, '');
  }

  removeExtension(text: string) {
    return text.replace(/\.[^/.]+$/, '');
  }

  generateJsonLdScript(): string {
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "GovernmentService",
      "@id": window.location.href,
      "name": this.data.title,
      "serviceType": this.data?.service_category?.name || "",
      "serviceOperator": {
        "name": "Comune di Padova"
      },
      "areaServed": {
        "name": "Padova"
      },
      "audience": {
        "name": "",
        "audienceType": this.cleanHtmlTags(this.data?.service_purpose?.processed) || ""
      },
      "availableChannel": {
        "name": "Dove rivolgersi",
        "serviceUrl": window.location.href,
        "serviceLocation": {
          "name": this.data?.service_responsible[0]?.title || "",
          "address": {
            "streetAddress": this.data?.service_responsible[0]?.org_unit_headquarters[0]?.place_address || "",
            "postalCode": this.data?.service_responsible[0]?.org_unit_headquarters[0]?.place_cap || "35100",
            "addressLocality": "Padova"
          }
        }
      }
    };
    return `<script data-element="metatag" type="application/ld+json">${JSON.stringify(jsonLd)}</script>`;
  }
}